import { BorderColors } from "@abel-technologies-as/components";
import styled from "styled-components";

const Devider = styled.div`
	margin-left: -24px;
	width: calc(100% + 46px);
	border-bottom: 1px solid ${BorderColors.Secondary};
`;

const SelectContainer = styled.div`
	margin-top: 25px;
	margin-bottom: 25px;
`;

const TableContainer = styled.div`
	margin-top: 10px;
	margin-bottom: 10px;
`;

const ModalBody = styled.div`
	max-width: 680px;
`;

export { Devider, ModalBody, SelectContainer, TableContainer };
